// Encode string → Uint8Array
const encodeUTF8 = (text) => {
  return new TextEncoder().encode(text);
};
// Convert ArrayBuffer → Base64
const arrayBufferToBase64 = (buffer) => {
  return btoa(String.fromCharCode(...new Uint8Array(buffer)));
};

export const encryptAES = async (text, keyString) => {
  try {
    if (!keyString) {
      throw new Error("encryptAES:'keyString' are required.");
    }

    if (!window?.crypto?.subtle) {
      throw new Error('encryptAES: Web Crypto API is not available in this environment.');
    }

    const keyBytes = encodeUTF8(keyString);

    const cryptoKey = await window.crypto.subtle.importKey('raw', keyBytes, { name: 'AES-CBC' }, false, ['encrypt']);

    // Generate IV
    const iv = window.crypto.getRandomValues(new Uint8Array(16));

    const encryptedBuffer = await window.crypto.subtle.encrypt(
      {
        name: 'AES-CBC',
        iv,
      },
      cryptoKey,
      encodeUTF8(text),
    );

    return {
      cipherBase64: arrayBufferToBase64(encryptedBuffer),
      ivBase64: arrayBufferToBase64(iv),
    };
  } catch (error) {
    console.error('encryptAES failed:', error);
    throw error;
  }
};
